import { PurchaseOrderTypeInterface } from "../../models/ProcurementModule/PurchateOrder/PurchaseOrderType";
import client from "../client";

class PurchaseOrderTypeService {
  async GetAll(page: number, pageSize: number) {
    try {
      const { data } = await client.post<PurchaseOrderTypeInterface[]>(
        `/api/PurchaseOrderTypes/get`,
        {
          page,
          pageSize,
        }
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      const { data } = await client.get<PurchaseOrderTypeInterface>(
        `/api/PurchaseOrderTypes/getbyid/${id}`
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Create(item: PurchaseOrderTypeInterface) {
    try {
      const { data } = await client.post<PurchaseOrderTypeInterface>(
        `/api/PurchaseOrderTypes/create`,
        item
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Update(id: string, item: PurchaseOrderTypeInterface) {
    try {
      const { data } = await client.post<PurchaseOrderTypeInterface>(
        `/api/PurchaseOrderTypes/update/${id}`,
        item
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Remove(id: string) {
    try {
      const { data } = await client.post<PurchaseOrderTypeInterface>(
        `/api/PurchaseOrderTypes/remove/${id}`,
        { url: "" }
      );
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new PurchaseOrderTypeService();
